//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { uuid } from '@/views/visual/dataScreen/js/utils/utils';
import baseList from '@/views/visual/dataScreen/js/option/base';
export default {
  inject: ["contain"],
  provide: function provide() {
    return {
      contain: this.contain
    };
  },
  data: function data() {
    return {
      baseList: baseList
    };
  },
  methods: {
    handleAdd: function handleAdd(option) {
      var first = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var obj = this.deepClone(option);
      obj.left = 0;
      obj.top = 0;
      obj.index = uuid();

      if (first) {
        this.contain.nav.unshift(obj);
      } else {
        this.contain.nav.push(obj);
      }
    }
  }
};